import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCustomUrl, getPage, getPartner, getProduct, getUser } from '../../utils/tracking';
import { getProducts } from '../../utils/tracking/get_products';

/* istanbul ignore next */
export function trackCallbackClick(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'CallBack_popup_open_floating_block',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

export function trackShowPhoneClick(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  user: IUserSchema | null,
  abGroup: number,
  kpId: number | null,
  bot?: boolean,
) {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: `Open_card_floating_block${bot ? '_bot' : ''}`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  });
}

/* istanbul ignore next */
export function trackFirstMessageClick(offer: IOfferSchema, agent: IAgentSchema | null) {
  const products = getProduct(offer, agent);

  ca('event', {
    action: 'send_message',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
}

/* istanbul ignore next */
export function trackFirstMessageShowPopup(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  type?: 'open_message' | 'open_phone',
) {
  ca('event', {
    action: type ? type : 'open',
    category: 'Message_popup',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackFirstMessageSent(offer: IOfferSchema, user: IUserSchema | null) {
  ca('event', {
    action: 'send_message',
    category: 'Message_popup',
    label: `${offer.id}${user ? `/${user.realtyUserId}` : ''}`,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackMessageSent(offer: IOfferSchema, user: IUserSchema | null) {
  ca('event', {
    action: 'send_message_overlay',
    category: 'Message_popup',
    label: `${offer.id}${user ? `/${user.realtyUserId}` : ''}`,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackAgentAvailabilityMessageSent(offer: IOfferSchema, agent: IAgentSchema, user: IUserSchema) {
  ca('event', {
    action: 'send_message_inactive',
    category: 'Message_popup',
    label: `${offer.id}${user ? `/${user.realtyUserId}` : ''}`,
    name: 'oldevent',
    products: getProduct(offer, agent),
  });
}

/* istanbul ignore next */
export function trackGoToMessages() {
  ca('event', {
    action: 'go_to_messages',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
